<template>
	<v-container id="installment-import-view" fluid tag="section">
		<material-card icon="mdi-upload" icon-small title="دریافت فایل اکسل وام ها و اقساط" color="accent">
			<v-card-text>
				<v-row>
					<v-col cols="12">
						<div class="text-h5">
							لطفا فایل اکسل مورد نظر خود را با رعایت ترتیب ستون های زیر، انتخاب کنید.
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" class="text-center">
						<span v-for="(col, index) in columns" :key="col" class="info--text px-2" :class="{'border-left':index < columns.length - 1}">
							{{ col }}
						</span>
					</v-col>
				</v-row>
				<v-form ref="form" lazy-validation>
					<v-row align="center" justify="center">
						<v-col cols="12" sm="6">
							<v-file-input ref="file" v-model="file" :rules="[value => !!value || 'ابتدا فایل را انتخاب کنید.']" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" placeholder="" prepend-icon="mdi-file-excel-outline" label="جهت انتخاب فایل اینجا را کلیک کنید" />
						</v-col>
						<v-col cols="12" sm="2">
							<v-btn color="info" dark :loading="previewLoading" @click="preview">
								<v-icon dark>
									mdi-upload
								</v-icon>
								بارگذاری و پیش نمایش
							</v-btn>
						</v-col>
					</v-row>
				</v-form>
				<v-row v-if="localData.installmentImportPreviewModels.length > 0" class="mt-3">
					<v-col cols="12" style="max-height:300px; overflow-y:auto">
						<div class="text-h5 primary--text text-center mt-3 mb-3">
							لطفا پیش نمایش اطلاعات را بررسی کنید و در صورت تایید، بر روی دکمه تایید (پایین جدول) کلیک کنید.
						</div>
						<v-data-table :headers="headers" :items="localData.installmentImportPreviewModels" :items-per-page="500" class="elevation-1">
							<template v-slot:item="row">
								<tr>
									<td class="primary--text">
										{{ row.item.systemMsg }}
									</td>
									<td class="text-center">
										{{ row.item.nationalCode }}
									</td>
									<td class="text-center">
										{{ row.item.month }}
									</td>
									<td class="text-center">
										{{ row.item.loanCode }}
									</td>
									<td class="text-center">
										{{ row.item.installment.toString().toPriceFormat() }}
									</td>
								</tr>
							</template>
						</v-data-table>
						<div class="text-center pt-3">
							<v-btn color="info" dark :loading="submitLoading" @click="submit">
								<v-icon dark>
									mdi-upload
								</v-icon>
								تایید
							</v-btn>
						</div>
					</v-col>
				</v-row>
				<v-row v-if="summery">
					<v-col cols="12">
						<div class="text-success">
							تعداد وام ایجاد شده: {{ summery.userLoanNew }}
						</div>
						<div class="text-success">
							تعداد وام ویرایش شده: {{ summery.userLoanUpdate }}
						</div>
						<div class="text-success">
							تعداد قسط ایجاد شده: {{ summery.paymentNew }}
						</div>
						<div class="text-success">
							تعداد قسط ویرایش شده: {{ summery.paymentUpdate }}
						</div>
						<div v-if="summery.failed != 0" class="primary--text">
							تعداد ناموفق: {{ summery.failed }}
						</div>
						<div v-if="summery.errors.length > 0" class="primary--text">
							خطاها:
							<div v-for="err in summery.errors" :key="err">
								{{ err }}
							</div>
						</div>
					</v-col>
				</v-row>
			</v-card-text>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'InstallmentImportView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				columns: ['کد ملی', 'ماه', 'شماره وام', 'مبلغ قسط'],
				file: null,
				errorMessages: '',
				previewLoading: false,
				submitLoading: false,
				localData: {
					installmentImportPreviewModels: [],
				},
				headers: [
					{
						text: 'پیام سیستم',
						align: 'right',
						sortable: true,
						value: 'systemMsg',
						width: 200,
					},
					{
						text: 'کد ملی',
						align: 'center',
						sortable: true,
						value: 'nationalCode',
					}, {
						text: 'ماه',
						align: 'center',
						sortable: true,
						value: 'month',
					}, {
						text: 'شماره وام',
						align: 'center',
						sortable: true,
						value: 'loanCode',
					}, {
						text: 'قسط',
						align: 'center',
						sortable: true,
						value: 'installment',
					},
				],
				loans: [],
				summery: null,
			}
		},
		mounted() {
			this.loadLoans()
		},
		methods: {
			preview() {
				if (!this.$refs.form.validate()) { return }
				this.summery = null
				const formData = new FormData()
				formData.append('file', this.file)
				this.previewLoading = true
				api.post('admin/import/InstallmentImportPreview', formData, { contentType: 'multipart/form-data' })
					.then(
						response => {
							this.localData.installmentImportPreviewModels = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.previewLoading = false })
			},
			loadLoans() {
				api.get('admin/loan/list', null)
					.then(
						response => {
							this.loans = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			submit() {
				if (!this.$refs.form.validate()) { return }
				this.summery = null
				this.submitLoading = true
				api.post('admin/import/InstallmentImportSubmit', this.localData)
					.then(
						response => {
							this.localData.installmentImportPreviewModels = []
							toast.success('اطلاعات با موفقیت ذخیره شد.')
							this.summery = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.submitLoading = false })
			},
		},
	}
</script>
<style>
	.border-left {
		border-left: 1px solid #ddd;
	}
</style>
